import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Client, ScreenSize } from 'src/app/models';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GenericService } from 'src/app/generic.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-out-bank-detail-f2',
  templateUrl: './out-bank-detail-f2.component.html',
  styles: [
  ]
})
export class OutBankDetailF2Component implements OnInit {
  @Input() client: Client;
  @Input() uid: string;
  @Output() fdataChanged: EventEmitter<number> = new EventEmitter();
  f2loading = false;
  isFormChanged = false;
  title = 'Bank Detail To Receive Refund';
  f2Form: FormGroup;
  bsb: any;
  bsbSuccess: boolean;
  size = new ScreenSize();

  constructor(private formBuilder: FormBuilder, public service: GenericService, public dialog: MatDialog) {
    this.size = this.service.size;
  }

  get f(): any { return this.f2Form.controls; }

  ngOnInit(): void {
    this.loadForm();
  }

  loadForm(): void {
    this.isFormChanged = false;
    this.f2Form = this.formBuilder.group({
      f2Bsb: [null],
      f2Acc: [null],
      f2AccHolder: [this.client.firstName + " " + this.client.lastName],
    });

    this.f2Form.get('f2AccHolder').disable();

    this.onChanges();
  }

  onChanges(): void {
    this.f2Form.valueChanges.subscribe(val => {
      const f2Bsb = this.service.isValChanged(this.f2Form.get('f2Bsb').value, null);
      const f2Acc = this.service.isValChanged(this.f2Form.get('f2Acc').value, null);

      if (f2Bsb || f2Acc) {
        this.isFormChanged = true;
      } else {
        this.isFormChanged = false;
      }
    });
  }

  onSubmit(): void {
    this.f2loading = true;

    const acc = this.f2Form.get('f2Acc').value;
    const bsb = this.f2Form.get('f2Bsb').value;
    const name = this.f2Form.get('f2AccHolder').value;
    const uid = this.uid;

    const model = { Acc: acc, Bsb: bsb, Uid: uid, Name: name }


    this.service.postDataByModel('authority/UpdateBankDetails', model).then(response => {
      if (response.success) {
        this.service.success('Saved Successfully');
        this.isFormChanged = false;
        this.fdataChanged.emit();
        this.f2loading = false;
      } else {
        this.service.error(response.error);
      }
      this.f2loading = false;

    });
  }



}

